(function () {
    'use strict';
    'ngInject';

    angular.module('app.ctrls').controller('InvalidStoreCtrl', forgotPasswordCtrl);

    function forgotPasswordCtrl($rootScope, $scope, $location) {
        $rootScope.showHeader = false;
        $scope.shop = $location.search().shop;
        $scope.reason = $location.search().reason;
        $scope.message = $scope.reason === 'collective-retail' ? 'You do not have permission to use the app.' : null;

        if (!$scope.shop) {
            $location.path('/');
        }
    }
})();
